/* eslint-disable complexity */
/* eslint-disable max-lines */
import { FC, Fragment } from "react"
import { Table } from "../../../../../../../../_webui/layout/components/Table"
import { Regex } from "../../../../../../../../constant/Regex"
import { Title } from "../../../../../../../../_webui/layout/components/Typography/Title"
import { Translate } from "../../../../../../../../constant/Translate"
import { ScheduleInfoDetailsType } from "../../../../../models/add"
import { SchedulesAddDetailProps } from "./models"
import { Styled } from "./styled"
import { ItemSelect } from "../../../../../../../../_webui/layout/components/Form/Item/Select"
import { ItemInput } from "../../../../../../../../_webui/layout/components/Form/Item/Input"
import { validatorRequiredField } from "../../../../../../../../utils/validator/requiredField"
import { ItemDatePicker } from "../../../../../../../../_webui/layout/components/Form/Item/DatePicker"
import { requiredField } from "../../../../../../../../utils/requiredField"
import { PreLine } from "../../../../../../../../_webui/layout/components/Typography/PreLine"
import { validatorRangeDate } from "../../../../../../../../utils/validator/rangeDate"

const { REGEX_IS_DESKTOP } = Regex
const { StyledErrorTitle, StyledSchedulesAddTable, StyledTableRemark } = Styled
const {
  HELP_H0034,
  MESSAGE_E0151,
  TEXT_T215,
  TEXT_T234,
  TEXT_T235,
  TEXT_T405,
  TEXT_T439,
  TEXT_T282,
  TEXT_T283,
} = Translate

export const SchedulesAddDetail: FC<SchedulesAddDetailProps> = (props) => {
  const {
    assignmentValidMsg,
    departments,
    detailColumnsFirst,
    detailColumnsSecond,
    detailDataSource,
    detailIndexTabActive,
    detailRowSelection,
    detailSelectedRowKeys,
    detailTabsItems,
    detailValidMsg,
    handleAddDetailItem,
    handleDeleteDetailItem,
    isActiveBumon,
    isHiredLocally,
    isSubmitValidate,
    isTableLoading,
    isTwoWay,
    isVisibleBtn,
    onBlur,
    onChangeDate,
    onChangeTravelPurpose,
    onClickDetailTab,
    onKeyDown,
    purposeTravelList,
  } = props

  const _validatorRangeDate = isSubmitValidate
    ? [
        validatorRangeDate({
          namePathEndDate: "dispatchEndDate",
          namePathStartDate: "dispatchStartDate",
        }),
      ]
    : []

  return (
    <Fragment>
      <ItemSelect
        label={TEXT_T215}
        name="travelPurposeId"
        onChange={onChangeTravelPurpose}
        required
        rules={[validatorRequiredField]}
        selectItem={purposeTravelList}
      />

      <ItemDatePicker
        isBgBlue
        label={TEXT_T405}
        name="dispatchStartDate"
        onBlur={(event) => onBlur(event, TEXT_T405, "dispatchStartDate")}
        onKeyDown={(event) => onKeyDown(event, TEXT_T405, "dispatchStartDate")}
        required={isHiredLocally}
        rules={[...requiredField(isHiredLocally), ..._validatorRangeDate]}
      />

      <ItemDatePicker
        isBgBlue
        label={TEXT_T439}
        name="dispatchEndDate"
        onBlur={(event) => onBlur(event, TEXT_T439, "dispatchEndDate")}
        onChange={() => onChangeDate("dispatchStartDate")}
        onKeyDown={(event) => onKeyDown(event, TEXT_T439, "dispatchEndDate")}
        required={isHiredLocally}
        rules={requiredField(isHiredLocally)}
      />

      {assignmentValidMsg && (
        <StyledErrorTitle
          type="danger"
          titleLeft={<PreLine>{assignmentValidMsg}</PreLine>}
        />
      )}

      {isActiveBumon && (
        <ItemSelect
          isBgBlue
          label={TEXT_T234}
          name="bumonCd"
          required
          rules={[validatorRequiredField]}
          selectItem={departments}
          tooltip={HELP_H0034}
        />
      )}

      <ItemInput label={TEXT_T235} maxLength={100} name="mainPersonName" />
      {!isHiredLocally && (
        <Fragment>
          {detailValidMsg && <Title type="danger" titleLeft={detailValidMsg} />}
          {isTwoWay && <Title type="danger" titleLeft={MESSAGE_E0151} />}
          <StyledSchedulesAddTable
            activeKey={detailIndexTabActive}
            addText={TEXT_T282}
            columns={detailColumnsFirst}
            dataSource={detailDataSource}
            dataTableSelected={detailSelectedRowKeys}
            deleteText={TEXT_T283}
            handleAdd={handleAddDetailItem}
            handleDelete={handleDeleteDetailItem}
            id="table-schedules-add-detail"
            isHiddenVerticalBar
            isLoading={isTableLoading}
            isTableDetail
            isVisibleBtn={isVisibleBtn}
            items={detailTabsItems}
            onTabClick={onClickDetailTab}
            rowKey={(record: ScheduleInfoDetailsType) => record.travelDetailId}
            rowSelection={detailRowSelection}
            isHiddenScrollBar={detailDataSource.length < 3}
          />
        </Fragment>
      )}

      {REGEX_IS_DESKTOP && (
        <StyledTableRemark>
          <Table
            columns={detailColumnsSecond}
            dataSource={detailDataSource}
            isBackgroundFirstChild
            isLoading={isTableLoading}
            pagination={false}
          />
        </StyledTableRemark>
      )}
    </Fragment>
  )
}
